import { render, staticRenderFns } from "./MembroDetalhes.vue?vue&type=template&id=ecba5b6e"
import script from "./MembroDetalhes.vue?vue&type=script&lang=js"
export * from "./MembroDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports